import { Box, Collapse } from "@mui/material";
import React from "react";
import { Loader } from "Shared/Common/Loader";
import useLang from "Shared/hooks/useLanguage";

interface FlagDetailsCollapseProps {
  open: boolean;
  onClose: () => void;
  data: any;
  isLoading?: boolean;
}

const FlagDetailsCollapse: React.FC<FlagDetailsCollapseProps> = ({
  open,
  onClose,
  data,
  isLoading = false,
}) => {
  const { t } = useLang();

  return (
    <Collapse in={open} unmountOnExit>
      <div
        className="card mb-3"
        style={{
          borderRadius: "16px",
          overflow: "hidden",
          backgroundColor: "#FFFFFF",
          border: "1px solid #e8e5dc",
        }}
      >
        {/* Header */}
        <div
          className="d-flex align-items-center justify-content-between px-4 py-3"
          style={{
            backgroundColor: "#FFF4DE",
            borderBottom: "1px solid #e8dfc0",
          }}
        >
          <h5 className="m-0 fw-bold" style={{ color: "#333" }}>
            {t("Flag Details")}
          </h5>

          <button
            className="btn btn-secondary btn-sm fw-500"
            style={{
              color: "#181C32",
              borderRadius: "8px",
              minWidth: "80px",
            }}
            onClick={onClose}
          >
            {t("Close")}
          </button>
        </div>

        {/* Body */}
        <div className="px-4 py-3" style={{ backgroundColor: "#FFFFFF" }}>
          {isLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
              <Loader />
            </Box>
          ) : !data ? (
            <Box
              sx={{
                textAlign: "center",
                py: 4,
                color: "#999",
                fontStyle: "italic",
              }}
            >
              {t("No flag details to display.")}
            </Box>
          ) : (
            <>
              {/* Order & Accession Info */}
              <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap" }}>
                <span
                  className="fw-500 px-3 py-1"
                  style={{
                    backgroundColor: "#E9EEF4",
                    borderRadius: "20px",
                    fontSize: "13px",
                    color: "#333",
                  }}
                >
                  {t("Order #")}:&nbsp;&nbsp;
                  <strong>
                    {data?.orderNumber || data?.OrderNumber || ""}
                  </strong>
                </span>

                <span
                  className="fw-500 px-3 py-1"
                  style={{
                    backgroundColor: "#E9EEF4",
                    borderRadius: "20px",
                    fontSize: "13px",
                    color: "#333",
                  }}
                >
                  {t("Accession no")}:&nbsp;&nbsp;
                  <strong>
                    {data?.accessionNumber || data?.AccessionNumber || ""}
                  </strong>
                </span>
              </Box>

              {/* Flag Info */}
              <Box
                sx={{
                  borderLeft: "4px solid #dc3545",
                  bgcolor: "#F5F8FA",
                  borderRadius: "4px",
                  px: 2,
                  py: 1.5,
                  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                }}
              >
                <div className="mb-2">
                  <span className="fw-bold">{t("Flag Identity")}: </span>
                  <span>
                    {data?.flagIdentifier || data?.FlagIdentifier || ""}
                  </span>
                </div>

                <div>
                  <span className="fw-bold">{t("Flag Description")}: </span>
                  <span>
                    {data?.flagDescription || data?.FlagDescription || ""}
                  </span>
                </div>
              </Box>
            </>
          )}
        </div>
      </div>
    </Collapse>
  );
};

export default FlagDetailsCollapse;
